import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "item-content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "item-secondary-title" }, "Direct debit and terms and conditions acceptance", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Please read and acknowledge the direct debit authority & conditions.", -1)
const _hoisted_4 = { class: "d-flex flex-column gap-3 mb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Your first premium must be paid within 14 days from accepting the cover.", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " If you would like to change your premium frequency please contact us at least 2 days before your premium is due. ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, " If you do not have individual authority over the bank account, please select 'I want to switch to online banking' in the 'Payment method' section below. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SummaryCard = _resolveComponent("SummaryCard")!
  const _component_PaymentDetailsCard = _resolveComponent("PaymentDetailsCard")!
  const _component_SpecificConditions = _resolveComponent("SpecificConditions")!
  const _component_ConditionsOfThisAuthority = _resolveComponent("ConditionsOfThisAuthority")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_SummaryCard, {
          title: "Your direct debit details",
          items: _ctx.directDebitSummaryItems,
          "is-mobile-screen": _ctx.isMobileScreen
        }, null, 8, ["items", "is-mobile-screen"]),
        (_ctx.shouldShowPaymentDetailsCard)
          ? (_openBlock(), _createBlock(_component_PaymentDetailsCard, {
              key: 0,
              "payment-amount": _ctx.premiumAmount,
              "pro-rata": _ctx.proRataAmount,
              "first-premium-date": _ctx.firstPremiumDate,
              "next-premium-date": _ctx.nextPremiumDate,
              "benefit-renewal-date": _ctx.benefitRenewalDate,
              frequency: _ctx.frequency,
              "called-from": 'DDConfirmation'
            }, null, 8, ["payment-amount", "pro-rata", "first-premium-date", "next-premium-date", "benefit-renewal-date", "frequency"]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_5,
      _hoisted_6,
      _hoisted_7
    ]),
    _createVNode(_component_SpecificConditions),
    _createVNode(_component_ConditionsOfThisAuthority, { "uses-generic-wording": true })
  ], 64))
}